import { commonImages } from '@images/common-images';
import { contactImages } from '@images/contact-images';
import { menuItems } from '@images/menu-items-images';

// tabs.config.ts
export const tabsConfig = [
  {
    id: 'stream',
    icon: contactImages?.contact_stream,
    label: 'Stream',
    badge: null,
    panel: 0,
    conditions: [],
    flag: 'stream',
  },
  {
    id: 'lead',
    icon: menuItems?.lead_icon,
    label: 'Lead',
    badge: (stats: any) => stats?.totalleads?.length || 0,
    panel: 1,
    conditions: [],
    flag: 'lead',
  },
  {
    id: 'appointments',
    icon: menuItems?.calendar_icon,
    label: 'Appointments',
    badge: (appointments: any) => appointments?.length || 0,
    panel: 2,
    conditions: [],
    flag: 'appointments',
  },
  {
    id: 'tasks',
    icon: menuItems?.task_icon,
    label: 'Tasks',
    badge: (fullList: any) => fullList?.length || 0,
    panel: 3,
    conditions: [],
    flag: 'my_task',
  },
  {
    id: 'relatedProperty',
    icon: commonImages?.home_icon,
    label: 'Related Property',
    badge: (data: any) => (data.attached_listing?.length || 0) + (data.attached_properties?.length || 0), //+ (data.attached_contracts?.length || 0),
    panel: 4,
    conditions: [],
    flag: 'relatedProperty',
  },
  {
    id: 'relatedContacts',
    icon: contactImages?.user_circle_icon,
    label: 'Related Contacts',
    badge: (contacts: any) => contacts?.attached_contacts?.length || 0,
    panel: 5,
    conditions: [],
    flag: 'relatedContacts',
  },
  {
    id: 'associations',
    icon: commonImages?.user_group_icon,
    label: 'Associations',
    badge: null,
    panel: 6,
    conditions: [
      (role: string, permission: any) => ['master admin', 'operations manager'].includes(role) || permission?.includes('association_tab.view'),
    ],
    flag: 'associations',
  },
  {
    id: 'notes',
    icon: commonImages?.notes,
    label: 'Notes',
    badge: null,
    panel: 7,
    conditions: [],
    flag: 'notes',
  },
  {
    id: 'history',
    icon: contactImages?.history_icon,
    label: 'History',
    badge: null,
    panel: 8,
    conditions: [],
    flag: 'history',
  },
];
